import React from 'react';

const PageTitle404 = () => {
    return (
        <div id="page-title" className="page-title-404">
            <div className="wrapper text-center">
                <h1 className="large">
                  <i className="far fa-meh"></i>
                </h1>
            </div>
        </div>
    );
};

export default PageTitle404;
